import React from 'react';
import { Row, Col } from 'reactstrap';
import Body from '../Components/layout/Body';

//content sub-component with unique content for this page
function StaticResourcesContent(props) {
  const videoDivStyle = {
    padding:'100% 0 0 0',
    position: 'relative',
    marginRight:'5%',
    marginBottom: '1em'
  }
  const demoVideoDivStyle = {
    padding:'60% 0 0 0',
    position: 'relative',
    // marginRight:'5%',
    marginBottom: '1em'
  }
  const videoFrameStyle = {
    position: 'absolute',
    top:'0',
    left:'0',
    width: '100%',
    height: '100%'
  }
  //Nuances for linking to a static resource file
  //https://stackoverflow.com/questions/47718289/view-download-pdf-files-in-react-router-4
  //https://stackoverflow.com/questions/48572896/react-how-to-open-pdf-file-as-a-href-target-blank
  //if we just try a Link, it relaunches the app and sends it through the router
  //you can [import formsPdf from '../Docs/Access-nav-forms.pdf'], but that adds a hash string to the downloaded file
  //putting the files in /public/docs and just using straight <a> ended up working fine
  return(
    <>
    <div>
      <h4>Printable forms and guide document</h4>
      <p>The <a href="/docs/Access-nav-forms-and-guide.pdf" target="_blank" rel="noreferrer">printable forms and guide document</a> contains a variety of materials that you may find useful.</p>
      <p>First, it includes printable forms for those times when you need or want to use paper-and-pencil during an assessment instead of running the app on a device. 
        Use the link below to view, download, and print a PDF file with forms that match each step of Access Navigator (pages 3-23 in the doc). 
        (Note: these are not digitally fillable forms, since the purpose is to use it without a computing device.)
      </p>
      <p>The doc also contains Help, Resources, and an Appendix with all of Access Nav's suggestions for improving access.</p>
      <p>
        <a href="/docs/Access-nav-forms-and-guide.pdf" target="_blank" rel="noreferrer">View the Printable forms and guide document</a> 
      </p>
    </div>
    <div className="aa-review-row">
      <h4>Demo video</h4>
      <p>Here's a short video to get you going with Access Navigator <span class="aa-more-info">(2 min 30 sec)</span>:</p>
      <Row>
        <Col>
          <div style={demoVideoDivStyle}><iframe src="https://player.vimeo.com/video/922491206?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture" allowFullScreen style={videoFrameStyle} title="short-AccessNav-demo"></iframe></div><script src="https://player.vimeo.com/api/player.js"></script>
        </Col>
      </Row>
    </div>

    <div className="aa-review-row">
      <h4>Videos: Evaluating Abilities</h4>
      <p>Here are a few videos we made with tips for assessing physical abilities. These are also available within the app, in the Evaluating Abilities / Physical section.</p>
      <Row xs="1" sm="2" xl="3">
        <Col >
          <strong>Head movement</strong>
          <div style={videoDivStyle}><iframe src="https://player.vimeo.com/video/827366597?h=1b3ec1a624&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture" allowFullScreen style={videoFrameStyle} title="eval-abilities-head"></iframe></div><script src="https://player.vimeo.com/api/player.js"></script>
        </Col>
        <Col>
          <strong>Facial movement</strong>
          <div style={videoDivStyle}><iframe src="https://player.vimeo.com/video/827366571?h=8319fe4915&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture" allowFullScreen style={videoFrameStyle} title="evaluate-abilities-facial"></iframe></div><script src="https://player.vimeo.com/api/player.js"></script>
        </Col>
        <Col>
          <strong>Hand & fingers</strong>
          <div style={videoDivStyle}><iframe src="https://player.vimeo.com/video/827648519?h=2fe2a50419&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture" allowFullScreen style={videoFrameStyle} title="eval-abilities-hand-fingers"></iframe></div><script src="https://player.vimeo.com/api/player.js"></script>
        </Col>
        <Col >
          <strong>Elbow movement</strong>
          <div style={videoDivStyle}><iframe src="https://player.vimeo.com/video/850625782?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture" allowFullScreen style={videoFrameStyle} title="eval-abilities-elbow"></iframe></div><script src="https://player.vimeo.com/api/player.js"></script>
        </Col>
        <Col>
          <strong>Knee / leg movement</strong>
          <div style={videoDivStyle}><iframe src="https://player.vimeo.com/video/807618568?h=0ee21eadfc&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture" allowFullScreen style={videoFrameStyle} title="leg-knee-eval-abilities.mp4"></iframe></div><script src="https://player.vimeo.com/api/player.js"></script>
        </Col>
      </Row>
    </div>
    <div className="aa-review-row">
      <h4>Videos: Remedies</h4>
      <p>These videos may give you some ideas that can improve an individual's access. These are also available within the app, in the Test-drive Solutions / Interpret section.</p>
      <Row xs="1" sm="2" xl="3">
        <Col >
          <strong>Head tracking</strong>
          <div style={videoDivStyle}><iframe src="https://player.vimeo.com/video/850631929?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture" allowFullScreen style={videoFrameStyle} title="head-tracking-tips-and-tricks"></iframe></div><script src="https://player.vimeo.com/api/player.js"></script>
        </Col>
        <Col>
          <strong>Issues with mouse clicks</strong>
          <div style={videoDivStyle}><iframe src="https://player.vimeo.com/video/917630073?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture" allowFullScreen style={videoFrameStyle} title="Issues with accurate mouse clicks"></iframe></div><script src="https://player.vimeo.com/api/player.js"></script>
        </Col>
        <Col>
          <strong>Common switch issues</strong>
          <div style={videoDivStyle}><iframe src="https://player.vimeo.com/video/807552878?h=5af0fa7509&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture" allowFullScreen style={videoFrameStyle} title="1-sw-position.mp4"></iframe></div><script src="https://player.vimeo.com/api/player.js"></script>
        </Col>
        <Col >
          <strong>Switch stability</strong>
          <div style={videoDivStyle}><iframe src="https://player.vimeo.com/video/807552966?h=41e9b745cc&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture" allowFullScreen style={videoFrameStyle} title="2-sw-stability.mp4"></iframe></div><script src="https://player.vimeo.com/api/player.js"></script>
        </Col>
      </Row>
    </div>
    <div className="aa-review-row">
      <h4>Other resources</h4>
      <div>
        <strong>Perspectives of people who use alternative access</strong>
        <p>These include videos of presentations from the <a href="https://aac-learning-center.psu.edu/webcasts-consumer-perspectives/" target="_blank" rel="noreferrer">The Future of AAC Research Summit</a> held in May 2024, and articles from a special free-access issue of the AAC Journal, based on the summit.</p>
        <ul>
          <li>
            <a href="https://doi.org/10.1080/07434618.2025.2513902" target="_blank" rel="noreferrer">Pancho Ramirez' (2025) article</a> describes his evolving use of AAC, including laser pointers, an air mouse, and his participation in clinical trials with a brain computer interface.
          </li>
          <li>
            Patrick Regan's <a href="https://aac-learning-center.psu.edu/2024/11/16/regan-2024/" target="_blank" rel="noreferrer">presentation</a> and <a href="https://doi.org/10.1080/07434618.2025.2513912" target="_blank" rel="noreferrer">AAC journal article</a> on “access challenges that I have experienced as someone who uses AAC, how my team and I have resolved them, and what challenges I face now.”  
          </li>
          <li>
            In Tim Jin's <a href="https://aac-learning-center.psu.edu/2024/11/09/jin-2024/" target="_blank" rel="noreferrer">presentation</a> and <a href="https://doi.org/10.1080/07434618.2025.2508484" target="_blank" rel="noreferrer">AAC journal article</a>, Tim relates his four decade journey with AAC, and the importance of AAC adapting “to the user, rather than the user adjusting to the device."
          </li>
        </ul>
      </div>
      <div>
        <strong>Software tools for access assessment</strong>
        <p>A few other software-based tools, besides Access Navigator, that may be of interest.</p>
        <ul>
          <li>
            <a href="https://sifts.ocali.org/" target="_blank" rel="noreferrer">SIFTS</a>. A web-based tool to assist AT team match a person's needs to AT features.
          </li>
          <li>
            <a href="https://kpronline.com/software" target="_blank" rel="noreferrer">KPR software</a>. Includes Compass software as well as free tools to support alternative access. From Access Nav team member Heidi Koester.
          </li>
        </ul>
      </div>
      <div>
        <strong>Assessment frameworks and practices</strong>
        <p>A non-exhaustive list of references that describe AT assessment processes, and provide support for following those processes.</p>  
        <ul>
          <li>
            WATI guides and forms. Three collections of materials on AT service delivery, mainly in school-based settings. Wisconsin, USA.
            <ul>
              <li>
                <a href="https://www.wati.org/free-publications/assistive-technology-consideration-to-assessment/" target="_blank" rel="noreferrer">AT consideration to assessment</a>
              </li>
              <li>
                <a href="https://www.wati.org/free-publications/assessing-students-needs-for-assistive-technology/" target="_blank" rel="noreferrer">Assessing students' needs for AT</a>
              </li>
              <li>
                <a href="https://www.wati.org/free-publications/wati-student-information-guide-process-forms/" target="_blank" rel="noreferrer">Student information guide process forms</a>
              </li>
            </ul>
          </li>
          <li>
            <a href="https://qiat.org/" target="_blank" rel="noreferrer">Quality Indicators for Assistive Technology Services (QIAT)</a>. A collection of resources and an email forum to support the development and delivery of AT services.
          </li>
          <li>
            <a href="https://www.rstce.pitt.edu/rstce_courses/rstce_courses_doc/05_guid_at_process_07.pdf" target="_blank" rel="noreferrer">Assessment: Guiding the Assistive Technology Process</a>. A Powerpoint deck reviewing Cook, Hussey, and Polgar's HAAT model of AT assessment, from the University of Pittsburgh, USA.
          </li>
          <li>
            <a href="https://ataem.org/general-at-assessment-frameworks-and-tools" target="_blank" rel="noreferrer">General AT assessment frameworks and tools</a>. A list of resources and links on AT assessment, from OCALI in Ohio, USA.
          </li>
        </ul>
      </div>
      <div>
        <strong>Alternative access AT</strong>
        <ul>
          <li>
            <a href="https://doi.org/10.1080/07434618.2025.2499676" target="_blank" rel="noreferrer">Supporting effective alternative access for individuals with physical disabilities</a>. Review article (2025) written by the Access Nav team.
          </li>
          <li>
            <a href="https://moodle.aac-learning-center.org/" target="_blank" rel="noreferrer">Alternative access module</a>. Free online learning from the AAC Learning Center / RERC on AAC.
          </li>
          <li>
            <a href="https://www.callscotland.org.uk/information/alternative-access/" target="_blank" rel="noreferrer">Alternative access</a>. A nice overview from CALLScotland.
          </li>
          <li>
            <a href="https://www.communicationmatters.org.uk/what-is-aac/access-methods/" target="_blank" rel="noreferrer">Access methods: Switches, keyboards, and eyegaze.</a> Another nice overview, this one from Communication Matters in the UK.
          </li>
          <li>
            <a href="https://www.wati.org/wp-content/uploads/2017/10/Ch4-ComputerAccess.pdf" target="_blank" rel="noreferrer">AT for access to computers</a>. A WATI resource that covers assessment (using the SETT framework) as well as specific implementation tips and product features. 
          </li>
        </ul>
      </div>
    </div>
    </>
  );
}

//main component for this page
//basic pattern is to set up the pageData, define the unique content for the page (above),
//then render the page using <Body> component
function StaticResources(props) {

  const pageData = {
    image: "",
    faIcon: "", //fa-user",
    majorHeading: "Resources for you!",
    title: ``,
    subTitle: "",
    learnMore: {linkText: "",
                title: "",
                content: ""
                },
    nextRoute: "", 
    continueDisabled: true, //we'll only use the Back button on these static pages
    sidebar: false
  }

  console.log("Rendering Resources page");
  
  return(
    <>
    <Body page={pageData} contentComponent={<StaticResourcesContent />} />
    </>
  );
}


export default StaticResources;